export default {
  header: {
    language: 'EN',
    languageMb: 'EN',
    logout: "LOG OUT",
    rule: "RULE",
    viewRule: "VIEW RULE",
    shrinkMenuName: 'PRODUCT CATEGORIES'
  },
  countdown: {
    begintime:'{name} will begin on',
    countDownText:"The countdown of {name} ",
    countDown:"Countdown"
  },
  end: {
    end:"Activity has ended.",
    order:"My Order"
  },
  common: {
    "0":{
      symbol: '{value}pt',
    },
    "1":{
      symbol: 'TWD{value}',
    },
    "2":{
      symbol: 'TWD{value}',
    },
    buyconfirm: "",
    confirmOrder: "Confirm Order",
    confirm: "Confirm",
    cancel: "Cancel",
    stay: "Stay",
    leave: "Leave",
    back: "Back",
    agreement:'AGREEMENT',
    rule: 'RULES',
    warning:"Warning",
    pt:"Point",
    remainAmount:"Amount",
    agree:"Agree",
    leaveMsg:"<div style='font-weight: bold;'>By leaving this page your pending order will be moved to “Unpaid” status, and the cart will empty – we'll keep the order on hold for you for few more minutes.</div><div style='margin-top: 20px;'>Click on “my Profile” icon (on the top of the page), to: <br />- Retrieve your cart and complete the transaction (Pay button) <br />Or <br />-Cancel the pending order and restore the unused quotas (Cancel button)</div><div style='margin-top: 20px;'>After 30 minutes from the cart’s creation, all the “Unpaid” orders became automatically Cancelled, unused quotas are restored</div>",
    lastName:"Last Name",
    firstName:"First Name",
    district:'District',
    address:'Address',
    needAddress:'Please fill in the logistics information',
    username:'Name',
    mobile:'Mobile'
  },
  index: {
    empty: "No available event !"
  },
  login: {
    userName: 'userName',
    nameTip: 'Please input user name',
    password: 'password',
    passwordTip: 'Please input user password',
    login: 'Login'
  },
  footer: {
    activity: 'Home',
    classify: 'Categories',
    cart: "Cart",
    my: 'My Profile'
  },
  goods: {
    specification: 'Specs',
    selectModel: 'selectModel',
    quantity: 'Qty',
    productDetails: 'Product Details',
    addCart: 'Add To Cart',
    buy: 'Buy',
    stock: 'Stock',
    exchange: "Redeem",
    minQuota: "Quota",
    sellOut: "Sold Out",
    productPrice: "Price",
    notFound: "Products are loading, please refresh this page if you cannot see the items.",
  },
  screen: {
    classify: 'classify',
    sort: 'sort',
    all: 'all',
    sortOne: 'Prices range from high to low',
    sortTwo: 'Prices range from low to high'
  },
  order: {
    confirmOrderExpire: "Please pay for your order before {expire}, otherwise your order may be invalid!",
    cancelTip:"Are you sure to cancel this order?",
    empty:"No orders.",
    logout:"Confirm to logout?",
    empty2:"No such orders.",
    myOrder: 'Orders',
    allOrder: 'All',
    noPayment: 'Unpaid',
    havePaid: 'Paid',
    shipped: 'Shipped',
    isAll: '',
    variable: ' Piece(s)',
    total: 'Total',
    subtotal:"Subtotal",
    cancelOrder: 'Cancel',
    cancelOrder1: 'Cancel Order',
    cancelSuccess:"The order has been cancelled successfully!",
    cancelFailed:"Failed, Please retry!",
    cancelBuy: 'Cancel',
    pay: 'Pay',
    orderStatus: 'Order Status',
    consignee: 'Name',
    orderTime: 'Order Date',
    orderNumber: 'Order No.',
    canceled: "Cancelled",
    allOrders: "All Orders",
    orderDetail: "Order Details",
    telephone: "Telephone",
    paymentMethod: "Payment Method",
    address: "Address",
    realPayment: "Actual Price",
    exportOrder: "Export Order",
    wechatPay:"WeChat Pay",
    pointPay:"Redeem by Point",
    pointPay1:"Point",
    outOfStock:"Out of stock items",
    payWechat:"WeChat Pay",
    payAlipay:"Alipay",
    prePayment: "Pre-payment",
    balance: "Balance",
    delivery: "Estimated delivery",
    deliveryMsg: "Parcels will be delivered to office or stores, 2 weeks after the end of the event. ",
    deliveryWeeks: "2 weeks"
  },
  cart: {
    selected1:"Selected ",
    yourPoint:"You Have ",
    yourAmount:"Your Remain Amount ",
    empty:"Cart Empty",
    confirmDelete: "Are you sure to remove this item from the shopping cart?",
    buy: "Buy",
    tip: 'Warning',
    confirm:"Confirm",
    deleteTip: 'Are you sure to remove this item from the shopping cart?',
    cancel: 'Cancel',
    affirm: 'Submit',
    isAll: 'Select All',
    settlement: 'Submit',
    selectNote: "Please select some items !",
    confirmOrder: "Each person can only submit {orderQty} order. Once you pay a order, the order can no longer been canceled or modified. Are you sure to submit the order?",
    continue: "Continue shopping",
    goHome: "Go shopping",
    delete: "Delete",
    selected: "{orderQty} Piece(s)"
  },
  global: {
    orderConfirm: "Please Confirm before Placing The Order",
    total: "Total",
    instant: "Confirm",
    spec: "Specification",
    model: "Model",
    noData: "No Data"
  },
  placeorder: {
    success: "Success！",
    lack: "One or more items in your order is now out of stock, we are adding rest of them to the order...",
    lackall: "All items in your order are now out of stock！",
    retry: "Oops！ Something went wrong, please retry!",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "You have reached the limit of some product!",
    globalqty: "You cannot buy any more products!",
    typeqty: "You have reached the limit of category!",
    catqty: "You have reached the limit of category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!"
  },
  cartMsg: {
    success: "Product has been successfully added to the shopping cart",
    lackall: "This item is now out of stock！",
    globalamount: "This campaign has reach the limit of total amount!",
    perskuqty: "Max 1 piece per SKU/Size (i.e. same style, same color, same material, same size)",
    globalqty: "You cannot buy any more products!",
    typeqty: "You reached the quota set for this item.",
    catqty: "You have reached the limit of this category!",
    orderqty: "You cannot place any more order!",
    pointlack: "You don't have enough point!",
    over: "This event is finished!",
    personalamount:"You have reached your amount limit!",
    0: "Product has been successfully added to the shopping cart",
    2: "This item is now out of stock！",
    3: "This item is now out of stock！",
    4: "This campaign has reach the limit of total amount!",
    5: "Max 1 piece per SKU/Size (i.e. same style, same color, same material, same size)",
    6: "You cannot buy any more products!",
    7: "You reached the quota set for this item.",
    8: "You have reached the limit of this category!",
    9: "You cannot place any more order!",
    10: "You don't have enough point!",
    11: "You have reached your amount limit!",
    12: "You remain amount is not enough!Please cancel the unpaid orders to retrive pts",
    13: "Max 2 piece per SKU (i.e. same style, same color, same material)",
    lastName:"Please input Last Name",
    firstName:"Please input First Name",
    address: "Please input address",
    District:"Please select district",
    mobile:"Please input mobile",
    correctmobile:"Please input valid mobile",
    retry: "Oops！ Something went wrong, please retry!",
  },
  session: {
    end: "This campaign is already finished.",
    start: "This campaign is not start yet.",
    text: "COUNTDOWN",
    countdown: "{days} Day(s) {hours}:{minutes}:{seconds}",
  },
  search: {
    info: "Please input keyword to search.",
    notfound: "Oops, we cannot find anything related to “{searchKeyWord}”",
    placeholder: "Search",
    cancel: "Cancel",
    history:"Search History"
  }
}




// WEBPACK FOOTER //
// ./src/locales/en.js